"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = require("react");

var _useNav = require("../useNav");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { keys.push.apply(keys, Object.getOwnPropertySymbols(object)); } if (enumerableOnly) keys = keys.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function getIsExpanded(navExpandedState) {
  // if navExpandedState is defined and equals expanded, return true.
  // if navExpandedState is undefined, fallback to screensize.
  return navExpandedState ? navExpandedState === _useNav.NAV_EXPANDED_STATES.EXPANDED : window.matchMedia(_useNav.MEDIA_QUERIES[2]).matches;
}

function useStickyLeftNav(_ref) {
  var getPreferredNavExpandedState = _ref.getPreferredNavExpandedState,
      setPreferredNavExpandedState = _ref.setPreferredNavExpandedState;

  var _useState = (0, _react.useState)({
    isExpanded: getIsExpanded(getPreferredNavExpandedState()),
    navExpandedState: getPreferredNavExpandedState()
  }),
      _useState2 = _slicedToArray(_useState, 2),
      _useState2$ = _useState2[0],
      isExpanded = _useState2$.isExpanded,
      navExpandedState = _useState2$.navExpandedState,
      setNavState = _useState2[1];

  var updateNavState = (0, _react.useCallback)(function (updates) {
    setNavState(function (state) {
      if (updates.navExpandedState) {
        if (updates.navExpandedState === (0, _useNav.getDefaultNavExpandedState)()) {
          setPreferredNavExpandedState(undefined);
          return _objectSpread({}, state, {}, updates, {
            navExpandedState: undefined
          });
        }

        setPreferredNavExpandedState(updates.navExpandedState);
      }

      return _objectSpread({}, state, {}, updates);
    });
  }, [setPreferredNavExpandedState]);
  var handleMediaQueryChange = (0, _react.useCallback)(function () {
    if (navExpandedState === (0, _useNav.getDefaultNavExpandedState)()) {
      return;
    }

    updateNavState({
      navExpandedState: navExpandedState,
      isExpanded: getIsExpanded(navExpandedState)
    });
  }, [navExpandedState, updateNavState]);
  (0, _react.useEffect)(function () {
    var matchMediaQuery = window.matchMedia(_useNav.MEDIA_QUERIES[2]);
    matchMediaQuery.addListener(handleMediaQueryChange);
    return function () {
      matchMediaQuery.removeListener(handleMediaQueryChange);
    };
  }, [handleMediaQueryChange]);

  function handleChangeNavExpandedState(newNavExpandedState) {
    updateNavState({
      isExpanded: getIsExpanded(newNavExpandedState),
      navExpandedState: newNavExpandedState
    });
  }

  return [{
    isExpanded: isExpanded,
    navExpandedState: navExpandedState
  }, handleChangeNavExpandedState];
}

var _default = useStickyLeftNav;
exports.default = _default;